export default __webpack_public_path__ + "bc7d5d89d2e396f8715d9bec8ca60937.svg";